import { get } from 'react-hook-form';
import { isNotSelectAll } from 'components/forms/multiSelectField/MultiSelectField.constants';
import { BaseOption } from 'components/forms/multiSelectField/MultiSelectField.types';
import { PROPERTIES_SELECTION } from './PropertyMultiSelectFilterField.constants';

export const extractPropertyUidsFromMultiSelect = (
  fieldName: string,
  formValues: Record<string, unknown>,
) => {
  const propertiesMultiSelect = get(formValues, fieldName) as
    | BaseOption[]
    | undefined;

  return propertiesMultiSelect?.filter(isNotSelectAll).map((o) => o.value);
};

export const extractPropertiesMultiSelectFields = (
  fieldName: string,
  formValues: Record<string, unknown>,
) => {
  const propertyRadioButton = formValues[fieldName] as string | undefined;

  const updateAllProperties =
    propertyRadioButton === PROPERTIES_SELECTION.ALL_PROPERTIES;

  const propertiesUids = extractPropertyUidsFromMultiSelect(
    `${fieldName}Properties`,
    formValues,
  );

  return { updateAllProperties, propertiesUids };
};
